/***************************************************************************/
"use client";
/***************************************************************************/

import React, { createContext, useContext } from "react";

type TPortalV1RootUrlContextType = {
  portalV1RootUrl: string | undefined;
};

const PortalV1RootUrlContext = createContext<TPortalV1RootUrlContextType>({
  portalV1RootUrl: "",
});

type PortalV1RootUrlProviderProps = {
  children: React.ReactNode;
  portalV1RootUrl: string | undefined;
};

const PortalV1RootUrlProvider: React.FC<PortalV1RootUrlProviderProps> = ({
  children,
  portalV1RootUrl,
}) => {
  return (
    <PortalV1RootUrlContext.Provider value={{ portalV1RootUrl }}>
      {children}
    </PortalV1RootUrlContext.Provider>
  );
};

const usePortalV1RootUrl = () => useContext(PortalV1RootUrlContext);

export { PortalV1RootUrlProvider, usePortalV1RootUrl };
